export const environments = {
  vendorUrl: process.env.VENDOR_URL,
  apiUrl: process.env.API_URL,
  CofeCoreServiceURL: process.env.COFE_CORE_SERVICE_URL,
  ServiceExchangeKey: process.env.SERVICE_EXCHANGE_KEY,
  firebaseConfig: {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_DATABASE_URL,
    projectId: process.env.FIREBASE_PROJECTID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGINGSENDERID,
    appId: process.env.FIREBASE_APP_ID,
  },
};
